(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-link/assets/javascripts/casino-link.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-link/assets/javascripts/casino-link.js');

'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const CasinoLink = _ref => {
  let href = _ref.href,
    title = _ref.title;
  return React.createElement(Link, {
    className: "casino-link",
    to: href
  }, title);
};
setGlobal('svs.components.casino_react.casinoLink.CasinoLink', CasinoLink);

 })(window);